module.exports = __webpack_public_path__ + "media/images/img-top3-4992df64768009435a1b20329ef45b8d.jpg";